import i18next from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';
export { I18nContext, I18nextProvider, Trans, composeInitialProps, getInitialProps, initReactI18next, useTranslation, withTranslation } from 'react-i18next';

// eslint-disable-next-line no-control-regex
var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var serializeCookie = function (name, val, options) {
  var opt = options || {};
  opt.path = opt.path || '/';
  var value = encodeURIComponent(val);
  var str = "".concat(name, "=").concat(value);
  if (opt.maxAge > 0) {
    var maxAge = opt.maxAge - 0;
    if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += "; Max-Age=".concat(Math.floor(maxAge));
  }
  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }
    str += "; Domain=".concat(opt.domain);
  }
  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }
    str += "; Path=".concat(opt.path);
  }
  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }
    str += "; Expires=".concat(opt.expires.toUTCString());
  }
  if (opt.httpOnly) str += '; HttpOnly';
  if (opt.secure) str += '; Secure';
  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }
  return str;
};
var cookie = {
  create: function (name, value, minutes, domain, cookieOptions) {
    if (cookieOptions === void 0) {
      cookieOptions = {
        path: '/',
        sameSite: 'strict'
      };
    }
    if (minutes) {
      cookieOptions.expires = new Date();
      cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60 * 1000);
    }
    if (domain) cookieOptions.domain = domain;
    document.cookie = serializeCookie(name, encodeURIComponent(value), cookieOptions);
  },
  read: function (name) {
    var nameEQ = "".concat(name, "=");
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  remove: function (name) {
    this.create(name, '', -1);
  }
};
var cookie$1 = {
  name: 'cookie',
  lookup: function (options) {
    var found;
    if (options.lookupCookie && typeof document !== 'undefined') {
      var c = cookie.read(options.lookupCookie);
      if (c) found = c;
    }
    return found;
  },
  cacheUserLanguage: function (lng, options) {
    if (options.lookupCookie && typeof document !== 'undefined') {
      cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
  }
};

var querystring = {
  name: 'querystring',
  lookup: function (options) {
    var found;
    if (typeof window !== 'undefined') {
      var search = window.location.search;
      if (!window.location.search && window.location.hash && window.location.hash.indexOf('?') > -1) {
        search = window.location.hash.substring(window.location.hash.indexOf('?'));
      }
      var query = search.substring(1);
      var params = query.split('&');
      for (var i = 0; i < params.length; i++) {
        var pos = params[i].indexOf('=');
        if (pos > 0) {
          var key = params[i].substring(0, pos);
          if (key === options.lookupQuerystring) {
            found = params[i].substring(pos + 1);
          }
        }
      }
    }
    return found;
  }
};

var hasLocalStorageSupport = null;
var localStorageAvailable = function () {
  if (hasLocalStorageSupport !== null) return hasLocalStorageSupport;
  try {
    hasLocalStorageSupport = window && window.localStorage !== null;
    var testKey = 'i18next.translate.boo';
    window.localStorage.setItem(testKey, 'foo');
    window.localStorage.removeItem(testKey);
  } catch (e) {
    hasLocalStorageSupport = false;
  }
  return hasLocalStorageSupport;
};
var localStorage$1 = {
  name: 'localStorage',
  lookup: function (options) {
    var found;
    if (options.lookupLocalStorage && localStorageAvailable()) {
      var lng = window.localStorage.getItem(options.lookupLocalStorage);
      if (lng) found = lng;
    }
    return found;
  },
  cacheUserLanguage: function (lng, options) {
    if (options.lookupLocalStorage && localStorageAvailable()) {
      window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
  }
};

var hasSessionStorageSupport = null;
var sessionStorageAvailable = function () {
  if (hasSessionStorageSupport !== null) return hasSessionStorageSupport;
  try {
    hasSessionStorageSupport = window && window.sessionStorage !== null;
    var testKey = 'i18next.translate.boo';
    window.sessionStorage.setItem(testKey, 'foo');
    window.sessionStorage.removeItem(testKey);
  } catch (e) {
    hasSessionStorageSupport = false;
  }
  return hasSessionStorageSupport;
};
var sessionStorage = {
  name: 'sessionStorage',
  lookup: function (options) {
    var found;
    if (options.lookupSessionStorage && sessionStorageAvailable()) {
      var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
      if (lng) found = lng;
    }
    return found;
  },
  cacheUserLanguage: function (lng, options) {
    if (options.lookupSessionStorage && sessionStorageAvailable()) {
      window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
  }
};

var __assign$4 = undefined && undefined.__assign || function () {
  __assign$4 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$4.apply(this, arguments);
};
var getDefaults = function () {
  return {
    order: ['querystring', 'cookie', 'sessionStorage', 'localStorage'],
    lookupQuerystring: 'locale',
    lookupLocalStorage: 'i18nLocale',
    lookupSessionStorage: 'i18nLocale',
    // cache user language
    caches: ['localStorage'],
    excludeCacheFor: ['cimode']
  };
};
var I18nLanguageDetector = /** @class */function () {
  function I18nLanguageDetector(services, options) {
    if (options === void 0) {
      options = {};
    }
    this.detectors = {};
    this.init(services, options);
  }
  I18nLanguageDetector.prototype.addDetector = function (detector) {
    this.detectors[detector.name] = detector;
  };
  I18nLanguageDetector.prototype.detect = function (detectionOrder) {
    var _this = this;
    if (!detectionOrder) {
      detectionOrder = this.options.order;
    }
    var detected = [];
    detectionOrder === null || detectionOrder === void 0 ? void 0 : detectionOrder.forEach(function (detectorName) {
      if (_this.detectors[detectorName]) {
        var lookup = _this.detectors[detectorName].lookup(_this.options);
        if (lookup && typeof lookup === 'string') lookup = [lookup];
        if (lookup) detected = detected.concat(lookup);
      }
    });
    if (this.services.languageUtils.getBestMatchFromCodes) {
      return detected; // new i18next v19.5.0
    }

    return detected.length > 0 ? detected[0] : undefined; // a little backward compatibility
  };

  I18nLanguageDetector.prototype.cacheUserLanguage = function (lng, caches) {
    var _this = this;
    if (!caches) {
      caches = this.options.caches;
    }
    if (!caches) {
      return;
    }
    if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) {
      return;
    }
    caches.forEach(function (cacheName) {
      var _a, _b;
      if (_this.detectors[cacheName]) {
        (_b = (_a = _this.detectors[cacheName]).cacheUserLanguage) === null || _b === void 0 ? void 0 : _b.call(_a, lng, _this.options);
      }
    });
  };
  I18nLanguageDetector.prototype.init = function (services, detectorOptions) {
    this.services = services;
    this.options = __assign$4(__assign$4({}, getDefaults()), detectorOptions);
    this.addDetector(querystring);
    this.addDetector(sessionStorage);
    this.addDetector(localStorage$1);
    this.addDetector(cookie$1);
  };
  return I18nLanguageDetector;
}();
I18nLanguageDetector.type = 'languageDetector';
var I18nLanguageDetector$1 = I18nLanguageDetector;

var __assign$3 = undefined && undefined.__assign || function () {
  __assign$3 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$3.apply(this, arguments);
};
var Metric = /** @class */function () {
  function Metric(config) {
    // 只支持web
    try {
      var pageUrl = window && window.location && window.location.origin + window.location.pathname;
      this.owl = new window.Owl.OWL(__assign$3({
        devMode: false,
        project: '',
        region: 'HK',
        pageUrl: pageUrl,
        realUrl: pageUrl,
        isSPA: true,
        autoCatch: {
          fetch: false,
          page: false,
          ajax: false,
          resource: false,
          js: false,
          console: false,
          pv: false
        },
        enableLogTrace: false
      }, config));
      this.newMetricInst = this.owl.newMetricInst();
    } catch (error) {
      console.error('@sailor/i18n-owl初始化错误', error);
    }
  }
  Metric.prototype.setTags = function (tags) {
    try {
      if (this.newMetricInst) {
        this.newMetricInst.setTags(tags);
      }
    } catch (error) {
      console.error('i18n setTags error', error);
    }
  };
  Metric.prototype.setMetric = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    try {
      if (this.newMetricInst) {
        (_a = this.newMetricInst).setMetric.apply(_a, args);
      }
    } catch (error) {
      console.error('i18n setMetric error', error);
    }
  };
  Metric.prototype.addError = function (error, options) {
    if (options === void 0) {
      options = {};
    }
    try {
      if (this.owl) {
        this.owl.addError(error, __assign$3({
          category: 'jsError',
          level: 'error'
        }, options));
      }
    } catch (error) {
      console.error('i18n addError error', error);
    }
  };
  return Metric;
}();
var Metric$1 = Metric;

/**
 * 比较版本
 * v1 > v2，返回1
 * v1 < v2，返回-1
 * v1 = v2，返回0
 * @param v1
 * @param v2
 * @returns
 */
function compareVersion(v1, v2) {
  v1 = "".concat(v1).split('.');
  v2 = "".concat(v2).split('.');
  var len = Math.max(v1.length, v2.length);
  while (v1.length < len) {
    v1.push('0');
  }
  while (v2.length < len) {
    v2.push('0');
  }
  for (var i = 0; i < len; i++) {
    var num1 = parseInt(v1[i]);
    var num2 = parseInt(v2[i]);
    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return -1;
    }
  }
  return 0;
}

/**
 *  判断是否是iphone的safari浏览器版本号大于
 * @param version 版本号
 */
function isIphoneSafariLowerThan(version) {
  return baseSafariLowerThan(version, 'iphone os');
}
function isMacSafariLowerThan(version) {
  return baseSafariLowerThan(version, 'mac os');
}
function baseSafariLowerThan(version, system) {
  var userAgent = window.navigator.userAgent.toLocaleLowerCase();
  var isSafari = userAgent.indexOf(system) !== -1 && userAgent.indexOf('safari') !== -1 && userAgent.indexOf('chrome') === -1;
  if (!isSafari) return false;
  var versionInfo = userAgent.match(/version\/([\d|\.]+)/);
  if (versionInfo && versionInfo[1]) {
    var safariVersion = versionInfo[1];
    return compareVersion(safariVersion, version) === -1;
  }
  return false;
}

var LOCALSTORAGE_CACHE_KEY = 'i18nLocale';

function getCacheLocale() {
  var value = localStorage.getItem(LOCALSTORAGE_CACHE_KEY);
  return value;
}

function isSupportOwl() {
  return typeof window !== 'undefined' && window.Owl && window.Owl.OWL && compareVersion(window.Owl.__version__, '1.10.0') !== -1;
}

var owlPlugin = {
  type: '3rdParty',
  init: function (instance) {
    // 目前只在配置了 backend 下开启owl
    if (!instance.modules.backend) return;
    var owl = instance.options.owl;
    var _a = owl || {},
      _b = _a.devMode,
      devMode = _b === void 0 ? false : _b,
      _c = _a.isSPA,
      isSPA = _c === void 0 ? true : _c,
      _d = _a.region,
      region = _d === void 0 ? 'HK' : _d,
      _e = _a.open,
      open = _e === void 0 ? true : _e;
    if (!devMode) {
      // 只上报 mykeeta.com
      var host = window.location.host;
      if (!host.endsWith('mykeeta.com')) {
        return;
      }
    }
    if (open && isSupportOwl()) {
      var metricInst = new Metric$1({
        project: 'com.sankuai.sailorfe.i18n.sdk',
        devMode: devMode,
        isSPA: isSPA,
        region: region
      });
      instance.$owl = metricInst;
      instance.services.$owl = metricInst;
    }
  }
};
var owlPlugin$1 = owlPlugin;

var MLocale = /** @class */function () {
  function MLocale(options) {
    this.baseName = options.baseName;
    this.language = options.language;
    this.calendar = options.calendar;
    this.calendars = options.calendars;
    this.region = options.region;
    this.script = options.script;
    this.textDirection = options.script;
    this.timeZones = options.timeZones;
  }
  MLocale.getCurrentLocale = function () {
    var _a;
    var localeOptions;
    // 编译时替换
    {
      var options_1 = getDefaults();
      var detectors = [querystring, sessionStorage, cookie$1, localStorage$1];
      var detected_1 = [];
      detectors.forEach(function (detector) {
        var lookup = detector.lookup(options_1);
        if (lookup && typeof lookup === 'string') lookup = [lookup];
        if (lookup) detected_1 = detected_1.concat(lookup);
      });
      var currentLanguage = detected_1.length > 0 ? detected_1[0] : undefined;
      var locale = new Intl.Locale(currentLanguage);
      localeOptions = {
        baseName: locale.baseName,
        language: locale.language,
        calendar: locale.calendar,
        calendars: locale.calendars,
        region: locale.region,
        script: locale.script,
        textDirection: (_a = locale.textInfo) === null || _a === void 0 ? void 0 : _a.direction,
        timeZones: locale.timeZones
      };
    }
    return new MLocale({
      baseName: localeOptions.baseName,
      language: localeOptions.language,
      calendar: localeOptions.calendar,
      calendars: localeOptions.calendars,
      region: localeOptions.region,
      script: localeOptions.script,
      textDirection: localeOptions.textDirection,
      timeZones: localeOptions.timeZones
    });
  };
  return MLocale;
}();

var __assign$2 = undefined && undefined.__assign || function () {
  __assign$2 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$2.apply(this, arguments);
};
var getDefaultOptions = function () {
  return {
    maximumFractionDigits: 2
  };
};
var NumberFormat = /** @class */function () {
  function NumberFormat(style, opts) {
    if (opts === void 0) {
      opts = {};
    }
    if (style === 'currency' && !opts.currency) {
      throw new Error('currency must be provided when style is currency');
    }
    if (style === 'unit' && !opts.unitCode) {
      throw new Error('unitCode must be provided when style is unit');
    }
    this.style = style;
    this.options = __assign$2(__assign$2({}, getDefaultOptions()), opts);
  }
  NumberFormat.getNumberFormat = function (opts) {
    return new NumberFormat('decimal', opts);
  };
  NumberFormat.getCurrencyFormat = function (opts) {
    var options = {};
    if (typeof opts === 'string') {
      options.currency = opts;
    } else {
      options = opts;
    }
    if (typeof options.currencyDisplay === 'undefined') {
      options.currencyDisplay = 'narrowSymbol';
    }
    return new NumberFormat('currency', options);
  };
  NumberFormat.getMeasureFormat = function (opts) {
    var options = {};
    if (typeof opts === 'string') {
      options.unitCode = opts;
    } else {
      options = opts;
    }
    return new NumberFormat('unit', options);
  };
  NumberFormat.getPercentFormat = function () {
    return new NumberFormat('percent');
  };
  NumberFormat.prototype.format = function (num) {
    var locale = MLocale.getCurrentLocale();
    var nf;
    if (this.style === 'currency') {
      var options = __assign$2({
        style: this.style
      }, this.options);
      if (options.currencyDisplay === 'narrowSymbol' && isIphoneSafariLowerThan('14.5') && isMacSafariLowerThan('14.1')) {
        // iphone safari >=14.5 mac safari >=14,1 只支持 symbol、code、name, HACK,后续增加货币需验证
        options.currencyDisplay = 'symbol';
        nf = new Intl.NumberFormat(locale.baseName, options);
        return nf.format(num).replace(/^[A-Za-z]+/, '').trim();
      } else {
        nf = new Intl.NumberFormat(locale.baseName, options);
      }
    } else if (this.style === 'percent') {
      nf = new Intl.NumberFormat(locale.baseName, __assign$2({
        style: this.style
      }, this.options));
    } else if (this.style === 'unit') {
      nf = new Intl.NumberFormat(locale.baseName, __assign$2({
        style: this.style,
        unit: this.options.unitCode
      }, this.options));
    } else {
      nf = new Intl.NumberFormat(locale.baseName, __assign$2({}, this.options));
    }
    return nf.format(num);
  };
  return NumberFormat;
}();

/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
  var result = {};
  skeleton.replace(DATE_TIME_REGEX, function (match) {
    var len = match.length;
    switch (match[0]) {
      // Era
      case 'G':
        result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
        break;
      // Year
      case 'y':
        result.year = len === 2 ? '2-digit' : 'numeric';
        break;
      case 'Y':
      case 'u':
      case 'U':
      case 'r':
        throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
      // Quarter
      case 'q':
      case 'Q':
        throw new RangeError('`q/Q` (quarter) patterns are not supported');
      // Month
      case 'M':
      case 'L':
        result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
        break;
      // Week
      case 'w':
      case 'W':
        throw new RangeError('`w/W` (week) patterns are not supported');
      case 'd':
        result.day = ['numeric', '2-digit'][len - 1];
        break;
      case 'D':
      case 'F':
      case 'g':
        throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
      // Weekday
      case 'E':
        result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
        break;
      case 'e':
        if (len < 4) {
          throw new RangeError('`e..eee` (weekday) patterns are not supported');
        }
        result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
        break;
      case 'c':
        if (len < 4) {
          throw new RangeError('`c..ccc` (weekday) patterns are not supported');
        }
        result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
        break;
      // Period
      case 'a':
        // AM, PM
        result.hour12 = true;
        break;
      case 'b': // am, pm, noon, midnight
      case 'B':
        // flexible day periods
        throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
      // Hour
      case 'h':
        result.hourCycle = 'h12';
        result.hour = ['numeric', '2-digit'][len - 1];
        break;
      case 'H':
        result.hourCycle = 'h23';
        result.hour = ['numeric', '2-digit'][len - 1];
        break;
      case 'K':
        result.hourCycle = 'h11';
        result.hour = ['numeric', '2-digit'][len - 1];
        break;
      case 'k':
        result.hourCycle = 'h24';
        result.hour = ['numeric', '2-digit'][len - 1];
        break;
      case 'j':
      case 'J':
      case 'C':
        throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
      // Minute
      case 'm':
        result.minute = ['numeric', '2-digit'][len - 1];
        break;
      // Second
      case 's':
        result.second = ['numeric', '2-digit'][len - 1];
        break;
      case 'S':
      case 'A':
        throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
      // Zone
      case 'z':
        // 1..3, 4: specific non-location format
        result.timeZoneName = len < 4 ? 'short' : 'long';
        break;
      case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
      case 'O': // 1, 4: miliseconds in day short, long
      case 'v': // 1, 4: generic non-location format
      case 'V': // 1, 2, 3, 4: time zone ID or city
      case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
      case 'x':
        // 1, 2, 3, 4: The ISO8601 varios formats
        throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
    }
    return '';
  });
  return result;
}

var __assign$1 = undefined && undefined.__assign || function () {
  __assign$1 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$1.apply(this, arguments);
};
var DateTimeFormat = /** @class */function () {
  function DateTimeFormat(opts) {
    if (opts === void 0) {
      opts = {};
    }
    this.options = opts;
    if (opts.skeleton) {
      var options = parseDateTimeSkeleton(opts.skeleton);
      this.options = __assign$1(__assign$1({}, opts), options);
    }
  }
  DateTimeFormat.getDateFormat = function (dateStyle) {
    if (dateStyle === void 0) {
      dateStyle = 'short';
    }
    return new DateTimeFormat({
      dateStyle: dateStyle
    });
  };
  DateTimeFormat.getTimeFormat = function (timeStyle) {
    if (timeStyle === void 0) {
      timeStyle = 'short';
    }
    return new DateTimeFormat({
      timeStyle: timeStyle
    });
  };
  DateTimeFormat.getDateTimeFormat = function (dateStyle, timeStyle) {
    return new DateTimeFormat({
      dateStyle: dateStyle,
      timeStyle: timeStyle
    });
  };
  DateTimeFormat.getDateFormatWithSkeleton = function (skeleton) {
    return new DateTimeFormat({
      skeleton: skeleton
    });
  };
  DateTimeFormat.prototype.format = function (datetime) {
    if (datetime === void 0) {
      datetime = new Date();
    }
    var locale = MLocale.getCurrentLocale();
    var dtfm = new Intl.DateTimeFormat(locale.baseName, __assign$1({}, this.options));
    return dtfm.format(datetime);
  };
  return DateTimeFormat;
}();

var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var RelativeTimeFormat = /** @class */function () {
  function RelativeTimeFormat(opts) {
    if (opts === void 0) {
      opts = {};
    }
    this.options = opts;
  }
  RelativeTimeFormat.getRelativeTimeFormat = function () {
    return new RelativeTimeFormat();
  };
  RelativeTimeFormat.prototype.format = function (val, unit) {
    var locale = MLocale.getCurrentLocale();
    var rtf = new Intl.RelativeTimeFormat(locale.baseName, __assign({
      numeric: 'auto',
      style: 'narrow'
    }, this.options));
    console.log('rtf = ', rtf);
    return rtf.format(val, unit);
  };
  return RelativeTimeFormat;
}();

var SUPPORT_CURRENCY = {
  HKD: {
    shortSymbol: 'HK$',
    englishName: 'Hong Kong Dollar',
    chineseName: '港元',
    ratio: 100,
    fractionPlaces: 2 // 计算和展示原始保留位数
  },

  USD: {
    shortSymbol: 'US$',
    englishName: 'US Dollar',
    chineseName: '美元',
    ratio: 100,
    fractionPlaces: 2 // 计算和展示原始保留位数
  },

  CNY: {
    shortSymbol: '¥',
    englishName: 'Chinese Yuan',
    chineseName: '人民币',
    ratio: 100,
    fractionPlaces: 2 // 计算和展示原始保留位数
  }
};
/**
 * 校验展示金额是否超过币种的精度要求
 * @param amount 货币数量
 * @param currencyCode 要校验的货币
 * @returns
 */
function checkAmountFraction(amount, currencyCode) {
  var currency = SUPPORT_CURRENCY[currencyCode];
  if (typeof amount !== 'number' || typeof currency === 'undefined') {
    return false;
  }
  var fractionPlaces = currency.fractionPlaces;
  var ratio = Math.pow(10, fractionPlaces);
  var formatVal = Math.round(amount * ratio) / ratio;
  return formatVal - amount === 0;
}
function getCurrencySymbol(options) {
  var locale = options.locale,
    currency = options.currency,
    _a = options.currencyDisplay,
    currencyDisplay = _a === void 0 ? 'narrowSymbol' : _a;
  {
    if (!locale || !currency) {
      throw 'getCurrencySymbol error: locale and currency is required';
    }
    var nf = NumberFormat.getCurrencyFormat({
      currency: currency,
      currencyDisplay: currencyDisplay,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    return nf.format(0).replace(/\d|\./g, '').trim();
  }
}

var default_1 = /** @class */function () {
  function default_1() {}
  default_1.getCurrentLocale = function () {
    return MLocale.getCurrentLocale();
  };
  default_1.getNumberFormat = function (opts) {
    return NumberFormat.getNumberFormat(opts);
  };
  default_1.getCurrencyFormat = function (opts) {
    return NumberFormat.getCurrencyFormat(opts);
  };
  default_1.getMeasureFormat = function (opts) {
    return NumberFormat.getMeasureFormat(opts);
  };
  default_1.getPercentFormat = function () {
    return NumberFormat.getPercentFormat();
  };
  default_1.getDateFormat = function (dateStyle) {
    if (dateStyle === void 0) {
      dateStyle = 'short';
    }
    return DateTimeFormat.getDateFormat(dateStyle);
  };
  default_1.getTimeFormat = function (timeStyle) {
    if (timeStyle === void 0) {
      timeStyle = 'short';
    }
    return DateTimeFormat.getTimeFormat(timeStyle);
  };
  default_1.getDateTimeFormat = function (dateStyle, timeStyle) {
    if (dateStyle === void 0) {
      dateStyle = 'short';
    }
    if (timeStyle === void 0) {
      timeStyle = 'short';
    }
    return DateTimeFormat.getDateTimeFormat(dateStyle, timeStyle);
  };
  default_1.getDateFormatWithSkeleton = function (skeleton) {
    return DateTimeFormat.getDateFormatWithSkeleton(skeleton);
  };
  default_1.getRelativeTimeFormat = function () {
    return RelativeTimeFormat.getRelativeTimeFormat();
  };
  default_1.checkAmountFraction = function (amount, currencyCode) {
    return checkAmountFraction(amount, currencyCode);
  };
  default_1.getCurrencySymbol = function (options) {
    return getCurrencySymbol(options);
  };
  return default_1;
}();
var default_1$1 = default_1;

function createInstance() {
  var instance = i18next.createInstance({
    parseMissingKeyHandler: function (key, defaultValue) {
      if (typeof defaultValue === 'undefined') {
        return '';
      }
      return defaultValue;
    },
    load: 'currentOnly',
    fallbackLng: 'en'
  }).use(ICU).use(I18nLanguageDetector$1).use(owlPlugin$1).use(initReactI18next);
  Object.defineProperty(instance, 'getText', {
    value: instance.t,
    writable: true,
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(instance, 'getCurrentLocale', {
    value: getCurrentLocale,
    writable: true,
    enumerable: false,
    configurable: true
  });
  function getCurrentLocale() {
    // 初始化完成
    if (instance.language) return instance.language;
    // 还未初始化完成， 配置了 lng 会覆盖 derector
    if (instance.options.lng) {
      return instance.options.lng;
    }
    var lngs = instance.services.languageDetector.detect();
    return instance.services.languageUtils.getBestMatchFromCodes(lngs);
  }
  return instance;
}
var i18nClient = createInstance();

export { default_1$1 as I18n, createInstance, getCacheLocale, i18nClient };
